import { render } from '@testing-library/react';
import React from 'react'
import '../App.css';
import { BrowserRouter, Route, Switch, withRouter} from 'react-router-dom';
import Edit from './EditSlideshows'

class SlidshowContainer extends React.Component {
    constructor(){
        super();
        this.state = {
        };
        
      this.OnChangeRoute = this.OnChangeRoute.bind(this);
    }


    OnChangeRoute = (e) =>{
        console.log(e.target.id);
        let path = 'edit';// + e.target.id;
        this.props.history.push({
            pathname: '/edit',
            search: '?query=' + this.props.id,
            state: { title: this.props.title, slides: this.props.slides, new: this.props.new, id: this.props.id }
          })

          //
    }

    render(){
        return(
            
            <div className="SlideshowContainer">
                <div className="SlideshowBtnTitle">{this.props.title}</div>
                <button className="SlideshowBtn" style={{ backgroundImage: 'url('+ this.props.slides[0] +')' }}>
                </button>
                <div className="SlideshowBtnModifiers">
                    <button className="EditBtn" id={this.props.id} onClick={this.OnChangeRoute}/>
                    <button className="TrashBtn" id={this.props.id} onClick={this.props.removeSlideshow}/>
                </div>
                
            </div>
        )
    }
}
export default withRouter(SlidshowContainer);

/*

style={{ backgroundImage: 'url('+ this.props.slides[0] +')' }}
export default props => (
    <div className="SlideshowContainer">
        <button className="SlideshowBtn">
            <div className="SlideshowBtnTitle">{props.title}</div>
            <div className="SlideshowBtnModifiers">
                <button className="EditBtn"/>
                <button className="TrashBtn"/>
            </div>
        </button>
    </div>
  );
  
*/
/*
export default props =>
class SlideshowContainer extends React.Component {
    render(){
        return(

        <div className="SlideshowContainer">
            <button className="SlideshowBtn">
                <div className="SlideshowBtnTitle">{props.title}</div>
                <div className="SlideshowBtnModifiers">
                    <button className="EditBtn"/>
                    <button className="TrashBtn"/>
                </div>
            </button>
        </div>
        )
    }
};*/